require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-5-ways-to-manage-front-end-assets-in-rails.json") })
        }
      }, "path---blog-5-ways-to-manage-front-end-assets-in-rails");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-5-ways-to-manage-front-end-assets-in-rails!./.cache/json/blog-5-ways-to-manage-front-end-assets-in-rails.json
// module id = 570
// module chunks = 231608221292675